import type { UIStringsOverride } from "../i18n-ui.ts";

/** Dutch (nl) UI strings. */
export const nl: UIStringsOverride = {
  actions: {
    addToCursor: "Toevoegen aan Cursor",
    addToVscode: "Toevoegen aan VS Code",
    askAI: "AI vragen over deze pagina",
    connectMcp: "Verbinden met MCP",
    copied: "Gekopieerd!",
    copyClaudeCode: "Claude Code-opdracht kopiëren",
    copyCode: "Code kopiëren",
    copyCodex: "Codex-opdracht kopiëren",
    copyMarkdown: "Kopiëren als Markdown",
    copyServerUrl: "Server-URL kopiëren",
    edit: "Bewerken op GitHub",
    export: "Exporteren",
    exportEpub: "Exporteren naar EPUB",
    exportPdf: "Exporteren naar PDF",
    generating: "Genereren…",
    openIn: "Openen in {name}",
    openInChat: "Openen in chat",
    scrollToTop: "Naar boven scrollen",
  },
  ask: {
    ai: "AI",
    clear: "Gesprek wissen",
    close: "Sluiten",
    copy: "Gesprek kopiëren",
    empty: "Stel een vraag over de documentatie.",
    error: "Sorry, er is iets misgegaan.",
    label: "Stel een vraag",
    placeholder: "Stel een vraag…",
    send: "Verzenden",
    tip: "Tip: Je kunt de chat openen en sluiten met",
    title: "AI vragen",
    you: "Jij",
  },
  banner: { dismiss: "Aankondiging sluiten" },
  changelog: {
    description: "Productupdates en releaseopmerkingen.",
    showReleases: "Releases voor {version} tonen",
    title: "Wijzigingslogboek",
  },
  content: { diagramError: "Dit diagram kon niet worden weergegeven." },
  feedback: {
    no: "Nee",
    question: "Was deze pagina nuttig?",
    thanks: "Bedankt voor je feedback!",
    yes: "Ja",
  },
  languageSwitcher: { label: "Taal", untranslated: "Niet vertaald" },
  nav: {
    back: "Terug",
    breadcrumb: "Kruimelpad",
    closeNavigation: "Navigatie sluiten",
    deprecated: "verouderd",
    featured: "Uitgelicht",
    githubRepository: "GitHub-repository",
    navigation: "Navigatie",
    primary: "Primair",
    sections: "Secties",
    toggleNavigation: "Navigatie tonen of verbergen",
    toggleTheme: "Kleurthema wisselen",
  },
  notFound: {
    description: "We konden de pagina die je zoekt niet vinden.",
    home: "Terug naar de startpagina",
    title: "Pagina niet gevonden",
  },
  page: {
    lastUpdated: "Laatst bijgewerkt op",
    next: "Volgende",
    pagination: "Paginering",
    previous: "Vorige",
    skipToContent: "Naar inhoud springen",
  },
  search: {
    all: "Alle",
    allLanguages: "Alle talen",
    askAi: "AI vragen",
    askAiHint: "Krijg direct antwoord van AI",
    button: "Zoeken",
    devOnly: "Zoeken is beschikbaar in de productiebuild.",
    error: "Er is iets misgegaan. Probeer het opnieuw.",
    label: "Documentatie doorzoeken",
    navigate: "navigeren",
    noResults: "Geen resultaten gevonden.",
    open: "openen",
    placeholder: "Documentatie doorzoeken…",
    popular: "Populair",
    preview: "voorbeeld",
    results: "Resultaten",
  },
  toc: { title: "Op deze pagina" },
};
